import React from 'react';
import { peerBenefits, peerChoices, useCases, useMoments } from '../../data/ferringConcept';
export function ExtensionsPanel() {
  const max = Math.max(...peerChoices.map(c => c.share));
  return <div className="grid gap-12 lg:grid-cols-2" data-id="element-40" data-mp="1svehb9lo92fr">
      <section data-id="element-41" data-mp="1ssjx9j6kljmv">
        <span className="inline-flex rounded-full border border-dashed border-navy/25 px-3 py-1 text-xs text-navy/55" data-id="element-42" data-mp="1sss7127ec8tu">Optional future direction</span>
        <h2 className="mt-4 text-[32px] font-medium leading-[1.05] tracking-[-0.03em] text-navy" data-id="element-43" data-mp="1jt57kly89d3f">Peer comparison</h2>
        <p className="mt-4 text-base leading-relaxed text-navy/65" data-id="element-44" data-mp="1oum4659oide7">
          <span className="text-navy" data-id="element-45" data-mp="19wjynpj37hub">“What would other fertility specialists do with this patient?”</span> The HCP could compare their
          answer with peers before receiving the product reveal.
        </p>
        <figure className="mt-6 rounded-xl border border-navy/10 bg-paper p-5" data-id="element-46" data-mp="34b34o22u83h3">
          <div className="flex items-baseline justify-between" data-id="element-47" data-mp="3994m6ikm7uqg">
            <p className="text-lg font-medium text-navy" data-id="element-48" data-mp="396id2ei2t764">You chose 225 IU</p>
            <p className="text-xs text-navy/40" data-id="element-49" data-mp="3hnvhcuykjiru">Illustrative data</p>
          </div>
          <ul className="mt-4 space-y-2" data-id="element-50" data-mp="3cq3onyq3nsml">
            {peerChoices.map(c => <li key={c.label} className="grid grid-cols-[64px_1fr_36px] items-center gap-3 text-xs" data-id="element-51" data-mp="3rehpk43yh70i">
                <span className={c.you ? 'font-medium text-navy' : 'text-navy/60'} data-id="element-52" data-mp="3mhr9hgs5ibf3">{c.label}</span>
                <span className="h-1.5 rounded-full bg-navy/[0.06]" data-id="element-53" data-mp="2yrn69aivkdom">
                  <span className={`block h-full rounded-full ${c.you ? 'bg-navy' : 'bg-navy/25'}`} style={{
                width: `${c.share / max * 100}%`
              }} data-id="element-54" data-mp="2tsakyu7njeo5" />
                </span>
                <span className="text-right font-mono tabular-nums text-navy/55" data-id="element-55" data-mp="37p7a8r84go2x">{c.share}%</span>
              </li>)}
          </ul>
        </figure>
        <ul className="mt-4 flex flex-wrap gap-2" data-id="element-56" data-mp="mzzz1vweuis6">
          {peerBenefits.map(b => <li key={b} className="rounded-full border border-navy/15 px-3 py-1.5 text-xs text-navy/75" data-id="element-57" data-mp="iyo9trhg7zki">
              {b}
            </li>)}
        </ul>
      </section>

      <section data-id="element-58" data-mp="3gsrj1lo6wqyg">
        <h2 className="text-[32px] font-medium leading-[1.05] tracking-[-0.03em] text-navy" data-id="element-59" data-mp="3gs83ucpxcgo4">One interaction. Many possible moments.</h2>
        <ul className="mt-6 flex flex-wrap gap-2" data-id="element-60" data-mp="3lq9k6pvyu1vw">
          {useCases.map(u => <li key={u} className="rounded-full border border-navy/15 bg-white px-4 py-2 text-sm text-navy" data-id="element-61" data-mp="3pt690yc3mu8a">
              {u}
            </li>)}
        </ul>
        <p className="mt-8 text-sm text-navy/45" data-id="element-62" data-mp="2y201hwu1tu8z">The same short interaction could work as</p>
        <ul className="mt-2" data-id="element-63" data-mp="3244uctcoamuk">
          {useMoments.map(m => <li key={m} className="border-t border-navy/10 py-3 text-base text-navy/80" data-id="element-64" data-mp="36v3czzl4vx0z">
              {m}
            </li>)}
        </ul>
      </section>
    </div>;
}